import {
  accountsService,
  callPlanService,
  callRouteService,
  campaignServiceNew,
  infoService,
  utilities,
} from '@/angularBridgeCode/ringbaPortal.servicesModule';
import {  
  ROUTE_CONTAINER_TYPES,
} from '../apiConstants';

export class RoutingPlansViewModel {

  activeActionRouteId = null;
  selectedTarget = null;
  currentRoute = null;

  conversionSettings = [];
  conversionSettingsMap = {};

  /** @type {{ type: 'new-target-route' }} */
  modal = null;


  /** @type {(routeContainer) => any} */
  _onUpdate = null;
  /** @type {(key: string) => string} */
  _translate = key => key;

  constructor(getProps) {
    this.getProps = getProps;
  }

  /** @type { 'callPlan' } */
  get routeContainerType() { return this.getProps().routeContainerType; }

  get routeContainer() { return this.getProps().routeContainer; }

  get routeType() { return this.getProps().routeType; }

  get isRPC() { return this.routeType === 'RPC' || this.routeContainer?.routingType === 'RPC'; }

  // TODO: remove usages from components
  /** @deprecated */
  get mode() { return 'edit'; }

  withOnUpdate(onUpdate) {
    this._onUpdate = onUpdate;
    return this;
  }

  withTranslate(translate) {
    this._translate = translate;
    return this;
  }

  async #loadRoutes() {
    if (this.routeContainer && !this.routeContainer.routes) {
      try {
        if (this.routeContainerType === ROUTE_CONTAINER_TYPES.CALL_PLAN ) {
          const response = await callPlanService.getCallRoutes(
            accountsService.currentAccountId,
            this.routeContainer.id
          ); 
          this.routeContainer.routes = response.data.routes || response.callRoutes || [];
        }
      } catch (err) {
        console.error('Error loading routes:', err);
        utilities.errorHandler(err);
      }
    }
  }

  initialize() {
    this.#loadConversionSettings();
    this.#loadRoutes();
  }

  /** Call it from nested components.
   * Should notify parent
   */
  onUpdate = () => {
    this._onUpdate?.(this.routeContainer);
  };

  activateRouteActions(callRouteId) {
    this.activeActionRouteId = this.activeActionRouteId == callRouteId ? null : callRouteId;
  }

  getConversionTypeName(conversionType) {
    if (conversionType === 'pingTree'){
      return this._translate('CAMPAIGN_STEP_ROUTING_CONVERSION_PING_TREE');
    }

    return this.conversionSettingsMap[conversionType]?.name ?? conversionType;
  }

  /* Used in the number-stepper directive */
  updateCallRoute(callRoute) {
    callRouteService.updateCallRoute(accountsService.currentAccountId, callRoute)
      .catch(utilities.errorHandler);
  }

  editCallRoute(callRoute) {
    this.activeActionRouteId = false;
    this.selectedTarget = callRoute.callTarget || callRoute.callTargetGroup || callRoute.callPingTree;
    this.currentRoute = angular.copy(callRoute);
    this.currentRoute.callConversion = callRoute.conversionSettings[0];
    // this.modal = $uibModal.open({
    //   templateUrl: 'scripts/shared/components/select-target/new-target-route.modal.html',
    //   scope: $scope,
    //   controllerAs: 'vm',
    //   size: 'xl'
    // });
    this.modal = { type: 'new-target-route' };
  }

  async deleteRoute(callRouteId) {
    try {
      let promise = null;
      if (this.routeContainerType === ROUTE_CONTAINER_TYPES.CALL_PLAN) {
        promise = callPlanService.deleteRoute(
          accountsService.currentAccountId,
          this.routeContainer.id,
          callRouteId,
        );
      } else if (this.routeContainerType === ROUTE_CONTAINER_TYPES.CAMPAIGN) {
        promise = campaignServiceNew.deleteRoute(
          accountsService.currentAccountId,
          this.routeContainer.id,
          callRouteId,
        );
      } else {
        throw new Error('Unknown routeContainerType');
      }

      await promise;

      utilities.showToaster('success', this._translate('TARGET_ROUTE_DELETE_SUCCESS'));
      this.onUpdate({
        routeContainer: this.routeContainer
      });
    } catch (error) {
      utilities.errorHandler(error);
    }
  }

  getHasTargetGroups() {
    const item = this.routeContainer;
    if (item?.routes?.length) {
      for (var i = 0; i < item.routes.length; i++) {
        var route = item.routes[i];
        if (route.callTargetGroup) {
          return true;
        }
      }
    }

    return false;
  }

  async #loadConversionSettings() {
    try {
      const response = await infoService.getConversionSettings();
      if (Array.isArray(response.data)) {
        this.conversionSettings = response.data;

        this.conversionSettingsMap = this.conversionSettings.reduce((acc, value) => {
          acc[value.conversionType] = value;
          return acc;
        }, {});
      }
    } catch (err) {
      utilities.errorHandler(err);
    }
  }
}